'use strict';

angular.module('shiftTraderApp')
  .controller('HomeCtrl', function ($scope, me, Notifications, ShiftTradesResource, $location, $compile,
                                    $rootScope, TimeService, Organizations, $http, $modal, $timeout, $state, Session,
                                    userAvailabilityChangeRequests, InternalAnalyticsService, OrganizationMessages) {
    $scope.me = me;

    if (_.isUndefined(me)) {
      $state.go('login');
    }

    $scope.todayDate = TimeService.getNowInStoreTime();
    try {
      $rootScope.$broadcast('setTopNavTitle', $scope.me.memberships[0].organization.name);
    } catch (e) {
      Rollbar.error(e, 'HomeCtrl \'me\' was not injected with data', {me: me});
    }
    $scope.highlights = {};

    $scope.uacr = _.find(userAvailabilityChangeRequests, function(uacr) {
      return !uacr.$isExpired() && uacr.user_id === $scope.me.id;
    });

    if ($scope.uacr) {
      if (!$scope.uacr.$hasBeenRespondedTo() ||
            ($scope.uacr.$hasBeenRespondedTo() &&
                !$scope.uacr.$hasInReviewAvailabilitySet() &&
                !$scope.uacr.$hasApprovedAvailabilitySet()) ) {
        $scope.uacrExpiresDate = $scope.uacr.expiration_date;
      }
    }

    Organizations.getCurrentOrg()
      .then(function(org) {
          $scope.allDepartments = org.departments;
          if (!_.isUndefined($scope.nextWorkPeriod) && $scope.nextWorkPeriod && _.has($scope.nextWorkPeriod, 'position_id') && !_.isNull($scope.nextWorkPeriod.position.department_id)) {
            $scope.nextWorkPeriod.position.department = _.find($scope.allDepartments, {id: $scope.nextWorkPeriod.position.department_id});
          }
        });

    OrganizationMessages.getCurrentOrganizationMessages(Session.getCurrentOrgId())
      .then(function(messages) {
        $scope.orgMessages = messages;
      }, function(response) {
        console.log('Failed to retrieve Store News', response);
      });

    $scope.goToMessage = function(message) {
      $location.path('storeAnnouncements/' + message.id);
    };

    $scope.goToPickups = function() {
      $state.go('pickups');
    };

    $scope.goToAskOff = function() {
      $state.go('profile.daysOff.overview', { userId: $scope.me.id });
    };

    $scope.goToSchedule = function() {
      $state.go('employeeSchedule.show', { userId: $scope.me.id });
    };

    ShiftTradesResource.query({user_id: $scope.me.id, active: true}, function (trades) {
      $scope.myTrades = _.invoke(trades, '$initialize');

      $scope.activeTrades = _.filter($scope.myTrades, function(t) {
        if (t.$isGiveaway()) {
          // check that Session.me is initiator of giveaway or has responded with a status of 10 (accepted)
          return (t.user.id === $scope.me.id ||
            _.any(t.shift_trade_responses, function(resp) {
              return resp.user.id === $scope.me.id && resp.acceptance_code === 10;
            })) &&
            t.$calculateActive(true);
        } else {
          return (t.trade_user.id === $scope.me.id || t.user.id === $scope.me.id) && t.$calculateActive(true);
        }
      });
    }, function () {
      console.log('Failed to retrieve trade records from server.');
      $scope.allTrades = [];
    });

    ShiftTradesResource.query({ active: true }, function (trades) {
      $scope.allTrades = _.invoke(trades, '$initialize');

      $scope.availableGiveAways = _.filter($scope.allTrades, function(t) {
        // Needs to be a giveaway that has not been accepted, approved, or disapproved and that I did not start
        return t.$isGiveaway() && t.user.id !== $scope.me.id  &&
          !_.any(t.shift_trade_responses, function(resp) {
            return _.include([10, 20, 21],resp.acceptance_code);
          }) &&
          t.$calculateActive(true) &&
          t.work_period.$isQualifiedForPickup($scope.me);
      });

      $scope.availablePickupHours = _.reduce(_.map($scope.availableGiveAways, function(t) {
        return t.work_period.range_twix.length('hours');
      }), function(a, x) { return a + x; }) || 0;
    }, function () {
      console.log('Failed to retrieve trade records from server.');
      $scope.allTrades = [];
    });

    $scope.openIntroMobile = function() {
      var modalInstance = $modal.open({
        templateUrl: 'views/introMobile.html',
        windowClass: 'modal_mobile_full',
        controller: ['$scope', '$modalInstance', 'Session', 'ServerUrls', 'UserOrgSettings', 'params', 'org', function($scope, $modalInstance, Session, ServerUrls, UserOrgSettings, params, org) {
          $scope.me = params.me;
          $scope.org = org;
          $scope.loadToPage = params.page;
          $scope.accessToken = Session.getAccessToken();
          $scope.serverUrl = ServerUrls.current.railsApi;
          $scope.hasUploadedAvatar = false;

          $scope.userOrgConfig = {};
          $scope.userOrgConfig.share_email_with_coworkers = $scope.me.memberships[0].user_org_config.share_email_with_coworkers;
          $scope.userOrgConfig.share_phone_with_coworkers = $scope.me.memberships[0].user_org_config.share_phone_with_coworkers;

          $timeout(function() {
            $scope.cameraWidth = $('#camera_wrapper').width();
          },0);

          $scope.close = function() {
            $modalInstance.dismiss('close');
          };

          $scope.saUserPictUploadCallback = function() {
            console.log('saUserPictUploadCallback');
            $scope.hasUploadedAvatar = true;
            return true;
          };

          $scope.takeMeHome = function() {
            $scope.me.$update({
              swm_intro_wizard_completed_at: moment.utc().format(),
              swm_intro_wizard_state: $scope.hasUploadedAvatar ? 2 : 1
            });

            var data = $scope.userOrgConfig;
            data.user_id = $scope.me.id;
            data.organization_id = $scope.me.memberships[0].organization.id;

            UserOrgSettings.create(data)
              .then(function(response) {
                console.log(response);
                return response;
              }, function() {
                return undefined;
              });

            $modalInstance.close();
          };

        }],
        resolve: {
          params: function() {
            return {
              me: $scope.me,
              page: 0
            };
          },
          org: ['Organizations', function(Organizations) {
            return Organizations.getCurrentOrg();
          }]
        }
      });
      modalInstance.result.then(function(result) {
            console.log('closed mobile Introduction with result' + result);
          },
          function(reason) {
            console.log('dismissed introduction mobile with reason ' + reason);
          });
    };

    $scope.changeLocation = function(path) {
      $location.path(path);
    };

    $scope.isWorkingToday = true;

    $scope.goToMyAvailability = function(){
      $state.go('profile.availability.main',{userId:me.id});
    };

    /* jshint ignore:start */
    if ($scope.me.swm_intro_wizard_state !== 1) {
      $scope.openIntroMobile();
    } else {
      addToHomescreen({
        startDelay: 5,
        skipFirstVisit: true,
        maxDisplayCount: 1
      });
    }
    /* jshint ignore:end */
  });
